import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row, Container, Input, Table } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { subDays } from 'date-fns'
import ReactPaginate from 'react-paginate';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import Segment from '../../components/Segment';
import ContentRow from './ContentRow';
import './index.css';
import "react-datepicker/dist/react-datepicker.css";

const defaultImg = 'https://wiki.tripwireinteractive.com/images/4/47/Placeholder.png';

const AIContentEdit = () => {
    const [showUnreviewedContent, setShowUnreviewedContent] = useState(true);
    const [contentList, setContentList] = useState([]);
    const [contentCategories, setContentCategories] = useState([]);
    const [page, setPage] = useState(1);
    const [startDate, setStartDate] = useState(subDays(new Date(), 7));
    const [sortType, setSortType] = useState('asc')

    const getContentList = () => {
        let uri = `content/list?page=${page}&limit=20&from=${moment(startDate).format("YYYY-MM-DD")}&sort=${sortType}`;
        if (showUnreviewedContent) {
            uri = `${uri}&is_content_reviewed=0`;
        }
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                if (response.status === 'ok') {
                    setContentList([]);
                    setContentList([
                        ...response.contents,
                    ]);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    const getContentCategories = () => {
        api.fetchAPI({
            method: 'get',
            uri: 'content_categories',
            success: (response) => {
                if (response.status === 'ok') {
                    const categories = [];
                    response.categories.forums.forEach(category => {
                        categories.push({
                            value: category.forum_id,
                            label: category.forum_title,
                        });
                    });
                    setContentCategories(categories)
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    const loadMore = () => {
        setPage(page + 1);
    }
    const toogleReviewedContent = () => {
        setShowUnreviewedContent(!showUnreviewedContent);
        setPage(1);
    }
    const handleCalendarClose = () => {
        setPage(1);
    }
    const handleSortChange = e => {
        setSortType(e.target.value);
        setPage(1);
    }
    useEffect(() => {
        getContentList();
        getContentCategories();
    }, [page, showUnreviewedContent, sortType, startDate]);
    console.log(sortType);
    return (
        <Container fluid>
            <Row>
                <Col xs={12}>
                    <h1>Review content</h1>
                </Col>
                <Col xs={4}>
                    <Button
                        size="sm"
                        color="primary"
                        onClick={toogleReviewedContent}
                        style={styles.toogleButton}
                    >
                        Chỉ hiện nội dung chưa chỉnh
                    </Button>
                </Col>
                <Col xs={4}>
                    <b>Start Date</b>
                    <DatePicker
                        placeholderText="Select start date"
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        onCalendarClose={handleCalendarClose}
                    />
                </Col>
                <Col xs={4}>
                    <Button
                        color="primary"
                        style={styles.loadMore}
                        onClick={loadMore}
                    >Tải thêm</Button>
                </Col>
            </Row>
            <Row>
                <Col xs={4}>
                    <b>Sort Type  </b>
                    <select
                        value={sortType}
                        onChange={handleSortChange}
                    >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                    </select>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Forum</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contentList.map(content =>
                                <ContentRow
                                    content={content}
                                    contentCategories={contentCategories}
                                />
                            )}
                        </tbody>
                    </Table>
                </Col>
                <Col xs={12}>
                    <br /><br /><br /><br />
                </Col>
            </Row>
        </Container>
    );
}

const styles = {
    row: {},
    creatorName: {
        fontSize: 12,
        marginTop: 6,
    },
    loadMore: {
        width: '100%',
    },
    toogleButton: {
        marginTop: 12,
        marginBottom: 12,
    },
};

export default AIContentEdit;


// WEBPACK FOOTER //
// ./src/pages/AIContentEdit/index.js